// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3NRrA","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2kD4g","obliqueLine":"membershipbadge_obliqueLine__29HRh"};